import React, { useRef } from "react";
import "./TeamSlider.css"; // We can reuse the same CSS
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper/core";
import "swiper/swiper-bundle.css";
import { Box, Typography } from "@mui/material";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import ImageBottomBanner from "../../assets/images/ImageflowerBanner.png";
import LeftArrow from "../../assets/icons/LeftArrowImage.png";
import RightArrow from "../../assets/icons/RightArrowImage.png";
import { partners } from "../../data/partner";
import linkedin from "../../assets/icons/linkedin.svg";

SwiperCore.use([Navigation]);

function PartnerSlider() {
  const swiperRef = useRef(null);
  const [selectedPartner, setSelectedPartner] = React.useState(null);

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const handleClick = (url) => {
    // Add https:// if not present
    const completeUrl = url.startsWith('http') ? url : `https://${url}`;
    window.open(completeUrl, '_blank');
  };

  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", sm: "1440px" },
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: { xs: "2rem", sm: "4rem" },
      }}
    >
      <Box>
        <button
          className="custom-prev-button portfolio-btn-btn"
          onClick={goPrev}
        >
          <Box sx={{ width: "3rem" }}>
            <img src={LeftArrow} alt="" width="100%" />
          </Box>
        </button>
      </Box>

      <Box
        sx={{
          width: { xs: "95%", sm: "88%" },
          height: { xs: "16rem", sm: "20rem" },
          position: "relative",
          marginTop: {xs: "1.5rem" ,sm: "3rem"},
        }}
      >
        <Box sx={{ width: "100%", height: "100%" }}></Box>
        <div className="team-crousel">
          <div className="swiper-main">
            <Swiper
              ref={swiperRef}
              spaceBetween={20}
              slidesPerView={3}
              centeredSlides={true}
              navigation={{
                nextEl: ".custom-next-button",
                prevEl: ".custom-prev-button",
              }}
              breakpoints={{
                0: {
                  slidesPerView: 2.3,
                  loop: true,
                  centeredSlides: false,
                  initialSlide: 0,
                },
                740: {
                  slidesPerView: 2.2,
                  loop: true,
                  centeredSlides: false,
                  initialSlide: 0,
                },
                1024: {
                  slidesPerView: 3,
                  centeredSlides: true,
                  loop: true,
                  initialSlide: 1,
                },
              }}
            >
              {partners.map((partner, index) => (
                <SwiperSlide key={index} style={{ display: 'flex', justifyContent: 'center' }}>
                  <Box
                    sx={{
                      cursor: 'pointer',
                      '&:hover': {
                        transform: 'scale(1.02)',
                        transition: 'transform 0.2s ease-in-out',
                      },
                      width: { xs: "13rem", sm: "16rem" },
                      height: { xs: "16rem", sm: "23rem" },
                      borderRadius: "1rem",
                      overflow: "hidden",
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                    onClick={() => handleClick(partner.linkedinUrl)}
                  >
                    <Box
                      sx={{
                        position: "relative",
                        borderRadius: "1rem",
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#f36b2b", // Dark background for bottom section
                      }}
                    >
                      {/* Image Container - 75% height */}
                      <Box
                        sx={{
                          height: "68%",
                          width: "100%",
                          overflow: "hidden",
                          borderTopLeftRadius: "1rem",
                          borderTopRightRadius: "1rem",
                        }}
                      >
                        <img
                          src={partner.image}
                          alt={partner.name}
                          style={{ 
                            width: "100%", 
                            height: "100%", 
                            objectFit: "cover",
                          }}
                        />
                      </Box>

                      {/* Box for Name, Designation and Company */}
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: "5%",
                          left: "50%",
                          transform: "translateX(-50%)",
                          zIndex: 2,
                          color: "#fff",
                          textAlign: "center",
                          width: "100%",
                          padding: "0 10px",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: { xs: "0.9rem", sm: "1.2rem" },
                            fontWeight: "400",
                            mb: 0.5,
                          }}
                        >
                          {partner.name}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: { xs: "0.6rem", sm: "0.8rem" },
                            mb: 0.5,
                          }}
                        >
                          {partner.designation}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: { xs: "0.6rem", sm: "0.8rem" },
                            fontWeight: "600",
                          }}
                        >
                          {partner.companyName}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: { xs: "0.6rem", sm: "0.8rem" },
                            fontWeight: "600",
                            display: "flex",
                            justifyContent: "center",
                            gap: "5px",
                            marginTop: "5px",
                            cursor: "pointer",
                          }}
                        >
                          <img src={linkedin} alt="" width="15px" />
                          View Profile
                        </Typography>
                      </Box>

                      {/* ImageBottomBanner */}
                      <Box
                        sx={{
                          zIndex: 1,
                          position: "absolute",
                          bottom: "35px",
                          width: { xs: "13rem", sm: "16rem" },
                        }}
                      >
                        <img src={ImageBottomBanner} alt="" width="100%" />
                      </Box>
                    </Box>
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </Box>

      <Box>
        <button
          className="custom-next-button portfolio-btn-btn"
          onClick={goNext}
        >
          <Box sx={{ width: "3rem" }}>
            <img src={RightArrow} alt="" width="100%" />
          </Box>
        </button>
      </Box>

      {/* If you want to add a popup for partners, you can create a PartnerPopup component */}
      {/* <PartnerPopup 
        partner={selectedPartner} 
        onClose={() => setSelectedPartner(null)} 
      /> */}
    </Box>
  );
}

export default PartnerSlider; 